import { ColorHues, Theme } from '@chakra-ui/react'

export interface NucbaColorsTheme extends Partial<Theme['colors']> {
  nucba: {
    primary: string
    primaryHover: string
    background: string
    backgroundGradient: string
    gray: string
    grayHover: string
    'black-70': string
    'white-70': string
    'white-30': string
    borderColor: string
  }
}

export const colors: NucbaColorsTheme = {
  nucba: {
    primary: '#ff005c',
    primaryHover: '#B40845',
    background: '#131415',
    backgroundGradient:
      'linear-gradient(324.93deg, #000000 0.74%, #2B2B2B 100%)',
    gray: '#1A202C',
    grayHover: '#2D3749',
    'black-70': 'rgba(0, 0, 0, 0.7)',
    'white-70': 'rgba(255, 255, 255, 0.7)',
    'white-30': 'rgba(255, 255, 255, 0.3)',
    borderColor: '#BFBABA',
  },
}
